import { useIntl } from "react-intl";
import { Box, Grid, Typography } from "@mui/material";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const RADetailsThresholdMessage = (props) => {

  const { styleModelPartCount } = props;
  const intl = useIntl();

  return (
    <Box id="RADetailsThresholdMessage" sx={{border: '2px solid red', borderRadius: 2}}> 
        <Grid container sx={{mt:0.5, mb:0.5}}>
            <Grid item xs={0.5} textAlign={'center'}>
                <PriorityHighIcon sx={{color:'red'}} fontSize="large" />
            </Grid>
            <Grid item xs={11.5}>
                <Typography sx={{color: 'red'}} variant="h6">
                    {intl.formatMessage({ id: "General.RADetailsThresholdMessage" })}
                </Typography>
            </Grid>
        </Grid>
    </Box>
  );
};

export default RADetailsThresholdMessage;